import { inject } from "@angular/core";
import { Router, Routes } from "@angular/router";
import { authRoutes } from "app/auth/auth.routes";
import { AuthenticationService } from "app/auth/authentication.service";
import { map } from "rxjs";
import { platformRoutes } from "./platform/platform.routes";
import { tenantRoutes } from "./tenant/module/tenant.routes";

// Order matters here: this mirrors the previous RouterModule.forChild/forRoot merge order,
// with the catch-all route last so it doesn't shadow the real routes above it.
export const appRoutes: Routes = [
    ...authRoutes,
    ...tenantRoutes,
    {
        path: "register",
        loadComponent: () =>
            import("./register/register-page/register-page.component").then(
                (m) => m.RegisterPageComponent,
            ),
    },
    {
        path: "administration",
        loadComponent: () =>
            import("./admin/admin-page/admin-page.component").then((m) => m.AdminPageComponent),
        canActivate: [
            () => {
                const router = inject(Router);
                const authenticationService = inject(AuthenticationService);

                return authenticationService.user$.pipe(
                    map((user) => {
                        if (!user) {
                            return router.parseUrl("/login");
                        }

                        if (!user.isGlobalAdmin) {
                            return router.parseUrl("/group");
                        }

                        return true;
                    }),
                );
            },
        ],
    },
    ...platformRoutes,
    {
        path: "",
        redirectTo: "/login",
        pathMatch: "full",
    },
    {
        path: "**",
        redirectTo: "/login",
    },
];
